import { ComponentChildren } from 'preact';
import type { DimensionProps } from '../utils/UNSAFE_interpolations/dimensions';
import { Flex } from '../UNSAFE_Flex';

type Props = DimensionProps & {
  children?: ComponentChildren;
};

/**
 * Center is a convenience component that creates a flexbox
 * with justifyContent: center and alignItems: center.
 *
 */
// TODO: How do I add background-color, border, etc?
function Center({ children, width = '100%', height = '100%', ...props }: Props) {
  return (
    <Flex {...props} justify="center" align="center" width={width} height={height}>
      {children}
    </Flex>
  );
}

export { Center };
